module.exports = __webpack_public_path__ + "img/ewangcheng1.f668e363.jpg";